import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyNextTier from 'loyalty/selectors/getLoyaltyNextTier'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { LoyaltyLandingPageTileDetails, loyaltyLandingPageBenefitTiles } from '../LoyaltyLandingPageData'
import LoyaltyLandingPageSmallTile from '../loyaltyLandingPageSharedSections/LoyaltyLandingPageSmallTile'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LoyaltyAccountTierProgressContent from './LoyaltyAccountTierProgressContent'
import LoyaltyAccountLandingPageYourBenefits from './LoyaltyAccountLandingPageYourBenefits'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import LoyaltyAccountLandingPageUserActivities from './LoyaltyAccountLandingPageUserActivities'

const Section = styled(VerticalSpacer)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

const SmallTilesSection = styled.div`
  display: grid;
  gap: ${rem(24)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const NextTierContent = styled(Pane)`
  padding: ${rem(24)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(28)} ${rem(24)};
  }
`

const ProgressSection = styled(Pane)`
  padding: ${rem(20)} ${rem(12)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} ${rem(24)};
  }
`

const nextTierBenefits: Record<App.LoyaltyTier, Array<LoyaltyLandingPageTileDetails>> = {
  bronze: [],
  silver: [loyaltyLandingPageBenefitTiles.lounge, loyaltyLandingPageBenefitTiles.travelshoot, loyaltyLandingPageBenefitTiles.tourExtras],
  gold: [loyaltyLandingPageBenefitTiles.lounge, loyaltyLandingPageBenefitTiles.upgrades, loyaltyLandingPageBenefitTiles.transfers],
  platinum: [loyaltyLandingPageBenefitTiles.transfers, loyaltyLandingPageBenefitTiles.upgrades, loyaltyLandingPageBenefitTiles.lounge],
}

function LoyaltyAccountBenefitsProgressContent() {
  const nextTier = useAppSelector(state => getLoyaltyNextTier(state))
  const [currentTier] = useCurrentLoyaltyTier()

  return <Section gap={24}>
    <ProgressSection>
      <LoyaltyAccountTierProgressContent />
    </ProgressSection>
    {currentTier !== 'bronze' && <LoyaltyAccountLandingPageYourBenefits />}
    {nextTier && <NextTierContent type={`tier-${nextTier}`}>
      <VerticalSpacer gap={20}>
        <Heading variant="heading4">
          Unlock {getLoyaltyTierDisplayName(nextTier)} and get access to these benefits
        </Heading>
        <SmallTilesSection>
          {nextTierBenefits[nextTier].map(benefit => <LoyaltyLandingPageSmallTile
            key={benefit.title}
            tile={benefit}
          />)}
        </SmallTilesSection>
      </VerticalSpacer>
    </NextTierContent>}
    <LoyaltyAccountLandingPageUserActivities />
  </Section>
}

export default LoyaltyAccountBenefitsProgressContent
